import { cx } from "../../lib/cx";
import Accent from "./Accent";

/**
 * Eyebrow + uppercase Oswald headline + optional lede. `dark` for the
 * blueprint and graphite grounds, `center` for centered intros.
 */
export default function SectionHeading({
  eyebrow,
  title,
  children,
  dark = false,
  center = false,
  as: Heading = "h2",
  className,
}) {
  return (
    <div
      className={cx(
        center && "mx-auto text-center",
        !dark && "on-light",
        "max-w-[720px]",
        className,
      )}
    >
      {eyebrow && (
        <span
          className={cx("eyebrow", dark ? "text-blue-soft" : "text-blue-deep")}
        >
          {eyebrow}
        </span>
      )}
      <Heading
        className={cx(
          "font-display mt-4 text-[34px] uppercase md:text-[46px] lg:text-[52px]",
          dark ? "text-white" : "text-slate",
        )}
      >
        <Accent>{title}</Accent>
      </Heading>
      {children && (
        <div
          className={cx(
            "mt-3 text-[17px] leading-relaxed",
            dark ? "text-white/85" : "text-muted",
          )}
        >
          {children}
        </div>
      )}
    </div>
  );
}
